export const homeObjOne = {
  id: "over",
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topLine: "Over mij",
  headLine: "Claudia Wenner",
  description:
    "Mijn naam is Claudia en ik ben er voor vrouwen die meer Energie, Balans en Vreugde in hun leven willen ervaren. Uit eigen ervaring weet ik hoe het is om je met weinig energie en kracht door je dag te slepen. Gelukkig weet ik inmiddels ook hoe je hier uit kan komen, zodat je je weer energiek en krachtvol voelt.",
  description2:
    "In mijn omgeving zie ik vaak hoe vrouwen meestal eerst voor alle anderen zorgen, en daarna pas aan zichzelf toekomen(of juist niet). Als je voor anderen zorgt moet er echter wel voldoende voor jezelf zijn, wat heb je anders te geven? Als je steeds uit een halfvolle kruik staat te schenken, is die snel leeg en blijf je uitgeput achter. Wie kent het niet? Achteraf dan denk je: ik heb toch altijd mijn best gedaan en voor iedereen gezorgd? Helaas ben je vergeten aan jezelf te denken. Neem het jezelf niet kwalijk, het is je zo geleerd. We worden al honderden jaren lang zo opgevoed.",
  description3:
    "Het goede nieuws is dat je je er nu van bewust bent en er iets aan kan veranderen! Graag wil ik je hierbij ondersteunen door middel van een holistische kijk op je levensstijl. Daarbij wil ik je laten zien en voelen waar je energie uit kan putten en hoe je je balast achter je kan laten. Om met lichtheid je weg te vervolgen. Samen gaan we er een positieve draai aan geven, zodat je niet meer in deze valkuil stapt.",
  buttonLabel: "Meer...",
  imgStart: false,
  img: require("../../images/claudia.jpeg"),
  alt: "Claudia",
  dark: true,
  primary: true,
  darkText: false,
};

export const homeObjTwo = {
  id: "contact",
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topLine: "Tarieven",
  description: "- Intakegesprek, fysiek of telefonisch, 30 tot 45 min: €30,-*",
  description2: "- Wandelcoaching 1,5uur: €80,-",
  description3: "- Kaart voor 3x wandelcoaching á 1,5uur: €220,-",
  buttonLabel: "Contact",
  imgStart: true,
  img: require("../../images/claudia.jpeg"),
  alt: "Claudia",
  dark: true,
  primary: true,
  darkText: false,
};
